(function () {
  var currentQuery = '';
  var abortController = null;
  var isSearchActive = false;

  function _debounce (fn, wait) {
    var t;
    return function () {
      var args = arguments;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(null, args); }, wait);
    };
  }

  function getSearchInputs () {
    return document.querySelectorAll('[data-collection-search]');
  }

  function getClearButtons () {
    return document.querySelectorAll('[data-collection-search-clear]');
  }

  function syncInputs (value) {
    getSearchInputs().forEach(function (input) {
      if (input.value !== value) input.value = value;
    });
    getClearButtons().forEach(function (btn) {
      btn.classList.toggle('visible', value.length > 0);
    });
  }

  function applySearch (query) {
    currentQuery = query.trim();

    if (abortController) {
      abortController.abort();
    }

    if (!currentQuery) {
      // Clear search — restore collection view via filter system
      isSearchActive = false;
      var filterEl = document.querySelector('grid-filter');
      if (filterEl && typeof filterEl.applyFilters === 'function') {
        filterEl.applyFilters();
      }
      return;
    }

    isSearchActive = true;
    fetchSearchResults(currentQuery);
  }

  function getCurrentFilterParams () {
    var form = document.querySelector('#FacetFiltersForm');
    if (!form) return '';
    var params = new URLSearchParams();
    form.querySelectorAll('[data-filter-input]:checked').forEach(function (input) {
      params.append(input.name, input.value);
    });
    return params.toString();
  }

  function fetchSearchResults (query) {
    abortController = new AbortController();

    var url = '/search?q=' + encodeURIComponent(query) +
      '&type=product&options[prefix]=last' +
      '&section_id=search-results-grid';

    // Include active filter params so search respects filters
    var filterParams = getCurrentFilterParams();
    if (filterParams) url += '&' + filterParams;

    var grid = document.querySelector('#collection-grid');
    var container = document.querySelector('#product-grid');
    if (container) container.style.opacity = '0.5';

    // Hide pagination during search (results are from search, not collection)
    var pagination = document.querySelector('pagination-handler');
    if (pagination) pagination.style.display = 'none';

    fetch(url, { signal: abortController.signal })
      .then(function (response) {
        if (!response.ok) throw new Error('Network response was not ok');
        return response.text();
      })
      .then(function (responseHtml) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(responseHtml, 'text/html');
        var results = doc.querySelector('#search-results-grid');

        if (grid) {
          if (results && results.children.length > 0) {
            grid.innerHTML = results.innerHTML +
              '<div class="collection-search-no-results">No products match your search.</div>';
          } else {
            grid.innerHTML = '<div class="collection-search-no-results" style="display:block">No products match your search.</div>';
          }
        }

        if (container) container.style.opacity = '';

        if (typeof window.initLazyImages === 'function') {
          window.initLazyImages();
        }

        // Load remaining search pages if results span multiple pages
        var paginationData = doc.querySelector('#search-pagination-data');
        if (paginationData) {
          var totalPages = parseInt(paginationData.getAttribute('data-search-total-pages'));
          var currentPage = parseInt(paginationData.getAttribute('data-search-current-page'));
          if (currentPage < totalPages) {
            loadRemainingSearchPages(query, currentPage + 1, totalPages, filterParams);
          }
        }
      })
      .catch(function (error) {
        if (error.name !== 'AbortError') {
          console.error('Search error:', error);
          if (container) container.style.opacity = '';
        }
      });
  }

  function loadRemainingSearchPages (query, page, totalPages, filterParams) {
    var url = '/search?q=' + encodeURIComponent(query) +
      '&type=product&options[prefix]=last' +
      '&section_id=search-results-grid' +
      '&page=' + page;
    if (filterParams) url += '&' + filterParams;

    fetch(url)
      .then(function (response) {
        if (!response.ok) throw new Error('Network response was not ok');
        return response.text();
      })
      .then(function (responseHtml) {
        // Stop if a new search has started
        if (query !== currentQuery) return;

        var parser = new DOMParser();
        var doc = parser.parseFromString(responseHtml, 'text/html');
        var results = doc.querySelector('#search-results-grid');
        var grid = document.querySelector('#collection-grid');
        var noResults = grid ? grid.querySelector('.collection-search-no-results') : null;

        if (grid && results && results.children.length > 0) {
          // Insert before the no-results element
          if (noResults) {
            noResults.insertAdjacentHTML('beforebegin', results.innerHTML);
          } else {
            grid.insertAdjacentHTML('beforeend', results.innerHTML);
          }
        }

        if (typeof window.initLazyImages === 'function') {
          window.initLazyImages();
        }

        if (page < totalPages) {
          loadRemainingSearchPages(query, page + 1, totalPages, filterParams);
        }
      })
      .catch(function (error) {
        console.error('Search pagination error:', error);
      });
  }

  var debouncedApply = _debounce(function (value) {
    applySearch(value);
  }, 350);

  function onInput (e) {
    var value = e.target.value;
    syncInputs(value);
    debouncedApply(value);
  }

  function onClear () {
    syncInputs('');
    applySearch('');
  }

  function init () {
    getSearchInputs().forEach(function (input) {
      input.addEventListener('input', onInput);
    });
    getClearButtons().forEach(function (btn) {
      btn.addEventListener('click', onClear);
    });
  }

  // Expose for the filter system
  window.collectionSearchGetQuery = function () {
    return currentQuery;
  };

  window.collectionSearchIsActive = function () {
    return isSearchActive;
  };

  window.collectionSearchFetch = function (query) {
    fetchSearchResults(query);
  };

  // Called when filter replaces the grid — clear search state if filter took over
  window.collectionSearchReapply = function () {
    if (!isSearchActive) return;
    var items = document.querySelectorAll('.collection-grid-item');
    var noResults = document.querySelector('.collection-search-no-results');
    if (noResults) {
      noResults.classList.toggle('visible', items.length === 0 && currentQuery.length > 0);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
